export default __webpack_public_path__ + "static/media/data_contributing_member.072aaf40.png";